export default __webpack_public_path__ + "static/media/ic-art-holding-dumbell.5b7ab9a5.svg";